import { render } from "./DriversReporting.vue?vue&type=template&id=7c04ea47&scoped=true"
import script from "./DriversReporting.vue?vue&type=script&lang=js"
export * from "./DriversReporting.vue?vue&type=script&lang=js"

import "./DriversReporting.vue?vue&type=style&index=0&id=7c04ea47&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c04ea47"]])

export default __exports__